import { createTheme } from "@mui/material";

/**
 * Styles taken from LUKB e-banking styleguide: https://lukb.invisionapp.com/overview/LUKB-E-Banking-Styleguide--Web-3.0--ckvd3w6ud74is01toh5xmfqb8/screens.
 * An account is needed to access this InVision project.
 */
const createLukbMuiTheme = (container?: HTMLElement) =>
    createTheme({
        breakpoints: {
            values: {
                sm: 0, // mobile
                md: 680, // tablet
                lg: 960, // desktop
            },
        },
        typography: {
            allVariants: {
                color: "#333",
            },
            fontFamily: "Yoga Sans",
            h1: {
                fontFamily: "Yoga Sans",
                fontSize: "56px",
                fontWeight: 300,
            },
            h2: {
                fontFamily: "Yoga Sans",
                fontSize: "48px",
                fontWeight: 300,
            },
            h3: {
                fontFamily: "Yoga Sans",
                fontSize: "32px",
                fontWeight: 400,
            },
            h4: {
                fontFamily: "Yoga Sans",
                fontSize: "28px",
                fontWeight: 500,
            },
            h5: {
                fontFamily: "Yoga Sans",
                fontSize: "24px",
                fontWeight: 400,
            },
            h6: {
                fontFamily: "Yoga Sans",
                fontWeight: 500,
                fontSize: "21px",
            },
            button: {
                fontFamily: "Yoga Sans",
                fontWeight: 500,
                fontSize: "16px",
            },
            body1: {
                fontFamily: "Yoga Sans",
                fontSize: "18px",
                lineHeight: "26px",
                fontWeight: 300,
            },
            body2: {
                fontFamily: "Yoga Sans",
                fontWeight: 400,
                fontSize: "16px",
            },
            caption: {
                fontFamily: "Yoga Sans",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "18px",
            },
            subtitle1: {
                fontFamily: "Yoga Sans",
                fontWeight: 500,
                fontSize: "18px",
                lineHeight: "30px",
            },
            subtitle2: {
                fontFamily: "Yoga Sans",
                fontWeight: 500,
                fontSize: "16px",
            },
        },
        components: {
            MuiFormControlLabel: {
                styleOverrides: {
                    label: {
                        fontSize: "16px",
                        lineHeight: "20px",
                    },
                },
            },
            MuiDialog: {
                styleOverrides: {
                    paper: {
                        maxWidth: "unset",
                    },
                },
            },
            MuiCssBaseline: {
                styleOverrides: {
                    WebkitFontSmoothing: "antialiased",
                    fontSmooth: "always",
                },
            },
            MuiStepConnector: {
                styleOverrides: {
                    lineHorizontal: {
                        borderColor: "rgba(0,0,0,0.12)",
                    },
                },
            },
            MuiPopover: {
                defaultProps: {
                    container: container,
                },
            },
            MuiPopper: {
                defaultProps: {
                    container: container,
                },
            },
            MuiModal: {
                defaultProps: {
                    container: container,
                },
            },
        },
    });

// .ts support for theme customization
declare module "@mui/material/styles" {
    interface BreakpointOverrides {
        xs: false; // removes the `xs` breakpoint from theme definition
        sm: true;
        md: true;
        lg: true;
        xl: false; // removes the `xl` breakpoint from theme definition
    }
}

export default createLukbMuiTheme;
